import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Get or create anonymous visitor ID (persisted in localStorage)
const getVisitorId = () => {
  const key = 'mylocalgo_visitor_id';
  let id = localStorage.getItem(key);
  if (!id) {
    id = 'v_' + crypto.randomUUID();
    localStorage.setItem(key, id);
  }
  return id;
};

// Fire-and-forget analytics event — never throws, never blocks UI
const track = (eventType, data = {}) => {
  try {
    axios.post(`${API}/analytics/event`, {
      visitor_id: getVisitorId(),
      event_type: eventType,
      ...data,
    }).catch(() => {}); // silent failure
  } catch {
    // silent failure
  }
};

export const trackPageVisit = (page) => track('page_visit', { page });
export const trackCategoryClick = (category) => track('category_click', { category });
export const trackOfferView = (offerId, merchantId) => track('offer_view', { offer_id: offerId, merchant_id: merchantId });
export const trackEventClick = (eventId) => track('event_click', { event_id: eventId });
export const trackPwaInstall = () => track('pwa_install', { page: 'login' });
